import React, { Component } from 'react';
import './admin.css';
import './Business/business.css';

class AdminLayout extends Component {

  render() {
    return (
      <div className="container-fluid pt-4">
        {this.props.children}
      </div>
    );
  }
}

export default AdminLayout;